import type { OwnTransportType } from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';

import { BaseIngredient } from './baseIngredient';

export class OwnTransportIngredient extends BaseIngredient<IngredientType.OwnTransport> {
  public ownTransportType: OwnTransportType;
  constructor(transportType: OwnTransportType) {
    super(IngredientType.OwnTransport);
    this.ownTransportType = transportType;
  }

  public setOwnTransportType(transportType: OwnTransportType): void {
    this.ownTransportType = transportType;
  }

  public isIngredientCorrect(): boolean {
    return true;
  }
}
